import axiosHeader from '_common/runs/axios';
import Validator from 'validatorjs';
import config from '_config';
import store from '@/store';
import axios from 'axios';
import auth from './auth';

window.isAlreadyFetchingAccessToken = false;

class BaseService {
  getUrl() {
    return config.API_URL;
  }

  getCep(cep) {
    const cepClean = cep.replace(/\D/g, '');
    const validacep = /^[0-9]{8}$/;
    if (cepClean !== '' && validacep.test(cepClean)) {
      axios.defaults.headers.common = {};
      return axios.get(`https://viacep.com.br/ws/${cepClean}/json`, null)
        .then(response => {
          axiosHeader();
          return response.data;
        })
        .catch(err => {
          throw err;
        });
    }
    return false;
  }

  request(
    url = this.getUrl(),
    data = null,
    method = 'get',
    responseType = null,
  ) {
    const params = method === 'get' ? data : {};

    return axios({
      method,
      url,
      data,
      params,
      responseType,
    })
      .then(response => this.handleResponse(response))
      .catch(this.handleError);
  }

  validate(data, rules, names = null) {
    const validation = new Validator(data, rules);

    if (names !== null) validation.setAttributeNames(names);

    if (validation.fails()) {
      Object.keys(validation.errors.all())
        .forEach(error => Promise.reject(new Error({
          error_description: validation.errors.all()[error][0],
        })));
    }

    return Promise.resolve();
  }

  createFormData(data, splitArray = false, arrayIndexProp = []) {
    const fd = new FormData();

    // for (let key in data) {
    //     let item = data[key]

    //     if (typeof item === 'boolean') {
    //         fd.append(key, item ? 1 : 0)
    //     } else if (splitArray &&  Array.isArray(item)) {
    //         let isIndexProp = arrayIndexProp.find(i => i === key)

    //         for (let index in item) {
    //             fd.append(`${key}[${index}]${isIndexProp ? '[_id]' : ''}`, item[index])
    //         }
    //     } else {
    //         fd.append(key, item)
    //     }
    // }

    Object.keys(data).forEach(key => {
      const item = data[key];

      if (typeof item === 'boolean') {
        fd.append(key, item ? 1 : 0);
      } else if (splitArray && Array.isArray(item)) {
        const isIndexProp = arrayIndexProp.find(i => i === key);

        Object.keys(item).forEach(index => {
          fd.append(
            `${key}[${index}]${isIndexProp ? '[_id]' : ''}`,
            item[index],
          );
        });
      } else {
        fd.append(key, item);
      }
    });

    return fd;
  }

  handleResponse(response) {
    return Object.assign(response.data, { message: (response.data.message) || response.message });
  }

  handleError(error) {
    if (error.response.status === 401) {
      if (!window.isAlreadyFetchingAccessToken) {
        const lastRoute = error.config;
        window.isAlreadyFetchingAccessToken = true;
        auth.refreshToken()
          .then(response => {
            window.isAlreadyFetchingAccessToken = false;
            lastRoute.headers.Authorization = response.data.access_token;
            // retry the last request
            return axios(lastRoute);
          });
      }
      window.location.href = '/public/login';
    }
    if (error.response.status === 403) {
      const { isCustomer } = store.state.user;
      if (isCustomer) {
        return auth.redirectCustomer(error.response.data);
      }
      auth.resetUser(error.response.data);
    }
    throw error.response ? error.response.data : error;
    // throw error
  }

  setParamsToIfPdf(pagination, pdf) {
    const parameters = {
      params: pagination,
      responseType: 'json',
    };

    if (pdf) {
      parameters.responseType = 'arraybuffer';
    }
    return parameters;
  }

  setFormData(object, formData, parent = '') {
    if (object) {
      Object.entries(object).map(field => {
        let label = field[0];
        if (parent !== '') {
          label = `${parent}[${field[0]}]`;
        }
        if (typeof field[1] === 'object' && !(field[1] instanceof File)) {
          return this.setFormData(field[1], formData, label);
        }
        formData.append(label, field[1]);
        return field;
      });
    }
    return formData;
  }
}

export default BaseService;
